// extracted by mini-css-extract-plugin
export default {"container":"AccordionDetails_container__hdaUh","details":"AccordionDetails_details__NGp1X","expand":"AccordionDetails_expand__XFWPx"};